import { useEffect, useState } from "react";

// Matches Tailwind's `lg` breakpoint (1024px). Below this we render the
// dedicated mobile layout; at/above it we keep the existing desktop layout.
const MOBILE_QUERY = "(max-width: 1023px)";

export default function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia(MOBILE_QUERY).matches
      : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener("change", handler);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return isMobile;
}
